import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Profile() {
    const [data, setData] = useState({
        type:'',
        name: '',
        phone: ''
    });
    const [isEditing, setIsEditing] = useState(false);
    const [id, setId] = useState(null);
    const [originalData, setOriginalData] = useState({}); // To store the original data
    const Email = localStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`https://api.sivammoto.in/api/user/${Email}`);
                console.log(response)
                const userData = {
                    type: 'update',
                    name: response.data.name,
                    phone: response.data.phone || '',
                    usertype: response.data.usertype,
                };
                setData(userData);
                setOriginalData(userData);
                setId(response.data.id); 
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [Email]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData((prevState) => ({ ...prevState, [name]: value }));
    };

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleCancel = () => {
        setData(originalData); // Revert to original data
        setIsEditing(false);
    };

    const handleSave = async () => {
        console.log(data)
        try {
            await axios.put(`https://api.sivammoto.in/api/user/${id}`, data);
            setIsEditing(false);
            localStorage.setItem('name', data.name);
        } catch (error) {
            console.error('Error saving data:', error);
        }
    };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Profile</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Profile</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>


            <div className="row">
                <div className='col-md-3'></div>

                <div className="col-md-6">
                    <div className="card card-warning">
                        <div className="card-header">
                            <h3 className="card-title">Profile Details</h3>
                        </div>
                        <div className="card-body">
                            <form>
                                {/* Hidden field for ID */}
                                <input type="hidden" name="id" value={id} />
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input type="text" name="name" value={data.name} onChange={handleInputChange} className="form-control" disabled={!isEditing} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label>Phone</label>
                                            <input type="text" name="phone" value={data.phone} onChange={handleInputChange} className="form-control" disabled={!isEditing} />
                                        </div>
                                    </div>
                                </div>
                                {isEditing ? (
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-primary mr-2"
                                            onClick={handleSave}
                                        >
                                            Save
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                ) : (
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleEdit}
                                    >
                                        Edit
                                    </button>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Profile